export  function getdata(){
	var obj = {
			headDataI: [{
					title: "项目",
					prop: 'title',
					width: "280px",
					custom: true,
				},
				{
					title: "行次",
					prop: 'grade',
					width: "100px",
				},
				{
					title: "本月数",
					prop: "cwbbqykjzd_1_x_1",
					custom: true,
					width: "200px"
				},
				{
					title: '本年累计数',
					prop: 'cwbbqykjzd_1_x_2',
					width: "200px",
					custom: true,
				},
			],
			headDataII: [{
					title: "项目",
					prop: 'title',
					width: "280px",
					custom: true,
				},
				{
					title: "本月数",
					prop: "cwbbqykjzd_1_x_1",
					custom: true,
					width: "300px"
				},
				{
					title: '本年累计数',
					prop: 'cwbbqykjzd_1_x_2',
					width: "200px",
					custom: true,
				},
			],
			tableDataII:[{
					title: "1．出售、处置部门或被投资单位所得收益",
					disabledcwbbqykjzd_1_x_1: false,
					disabledcwbbqykjzd_1_x_2: false,
					cwbbqykjzd_1_x_1: {
						cellCode: "cwbbwxz_1_1_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					cwbbqykjzd_1_x_2: {
						cellCode: "cwbbwxz_1_1_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				{
					title: "2．自然灾害发生的损失",
					disabledcwbbqykjzd_1_x_1: false,
					disabledcwbbqykjzd_1_x_2: false,
					cwbbqykjzd_1_x_1: {
						cellCode: "cwbbwxz_1_2_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					cwbbqykjzd_1_x_2: {
						cellCode: "cwbbwxz_1_2_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "3．会计政策变更增加(或减少)利润总额",
					disabledcwbbqykjzd_1_x_1: false,
					disabledcwbbqykjzd_1_x_2: false,
					cwbbqykjzd_1_x_1: {
						cellCode: "cwbbwxz_1_3_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					cwbbqykjzd_1_x_2: {
						cellCode: "cwbbwxz_1_3_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "4．会计估计变更增加(或减少)利润总额",
					disabledcwbbqykjzd_1_x_1: false,
					disabledcwbbqykjzd_1_x_2: false,
					cwbbqykjzd_1_x_1: {
						cellCode: "cwbbwxz_1_4_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					cwbbqykjzd_1_x_2: {
						cellCode: "cwbbwxz_1_4_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "5．债务重组损失",
					disabledcwbbqykjzd_1_x_1: false,
					disabledcwbbqykjzd_1_x_2: false,
					cwbbqykjzd_1_x_1: {
						cellCode: "cwbbwxz_1_5_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					cwbbqykjzd_1_x_2: {
						cellCode: "cwbbwxz_1_5_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "6．其他",
					disabledcwbbqykjzd_1_x_1: false,
					disabledcwbbqykjzd_1_x_2: false,
					cwbbqykjzd_1_x_1: {
						cellCode: "cwbbwxz_1_6_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					cwbbqykjzd_1_x_2: {
						cellCode: "cwbbwxz_1_6_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}
			],
			tableDataI: [{
					title: "一、主营业务收入",
					grade: '1',
					disabledcwbbqykjzd_1_x_1: false,
					disabledcwbbqykjzd_1_x_2: false,
					cwbbqykjzd_1_x_1: {
						cellCode: "cwbbwxz_1_1_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					cwbbqykjzd_1_x_2: {
						cellCode: "cwbbwxz_1_1_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				{
					title: "减：主营业务成本",
					grade: '4',
					disabledcwbbqykjzd_1_x_1: false,
					disabledcwbbqykjzd_1_x_2: false,
					cwbbqykjzd_1_x_1: {
						cellCode: "cwbbwxz_1_2_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					cwbbqykjzd_1_x_2: {
						cellCode: "cwbbwxz_1_2_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "主营业务税金及附加",
					grade: '5',
					disabledcwbbqykjzd_1_x_1: false,
					disabledcwbbqykjzd_1_x_2: false,
					cwbbqykjzd_1_x_1: {
						cellCode: "cwbbwxz_1_3_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					cwbbqykjzd_1_x_2: {
						cellCode: "cwbbwxz_1_3_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "二、主营业务利润（亏损以“－”号填列）",
					grade: '10',
					disabledcwbbqykjzd_1_x_1: false,
					disabledcwbbqykjzd_1_x_2: false,
					cwbbqykjzd_1_x_1: {
						cellCode: "cwbbwxz_1_4_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					cwbbqykjzd_1_x_2: {
						cellCode: "cwbbwxz_1_4_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "加：其他业务利润（亏损以“－”号填列）",
					grade: '11',
					disabledcwbbqykjzd_1_x_1: false,
					disabledcwbbqykjzd_1_x_2: false,
					cwbbqykjzd_1_x_1: {
						cellCode: "cwbbwxz_1_5_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					cwbbqykjzd_1_x_2: {
						cellCode: "cwbbwxz_1_5_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "减：营业费用",
					grade: '14',
					disabledcwbbqykjzd_1_x_1: false,
					disabledcwbbqykjzd_1_x_2: false,
					cwbbqykjzd_1_x_1: {
						cellCode: "cwbbwxz_1_6_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					cwbbqykjzd_1_x_2: {
						cellCode: "cwbbwxz_1_6_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "管理费用",
					grade: '15',
					disabledcwbbqykjzd_1_x_1: false,
					disabledcwbbqykjzd_1_x_2: false,
					cwbbqykjzd_1_x_1: {
						cellCode: "cwbbwxz_1_7_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					cwbbqykjzd_1_x_2: {
						cellCode: "cwbbwxz_1_7_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "财务费用",
					grade: '16',
					disabledcwbbqykjzd_1_x_1: false,
					disabledcwbbqykjzd_1_x_2: false,
					cwbbqykjzd_1_x_1: {
						cellCode: "cwbbwxz_1_8_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					cwbbqykjzd_1_x_2: {
						cellCode: "cwbbwxz_1_8_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "三、营业利润（亏损以“－”号填列）",
					grade: '18',
					disabledcwbbqykjzd_1_x_1: false,
					disabledcwbbqykjzd_1_x_2: false,
					cwbbqykjzd_1_x_1: {
						cellCode: "cwbbwxz_1_9_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					cwbbqykjzd_1_x_2: {
						cellCode: "cwbbwxz_1_9_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "加：投资收益（损失以“－”填列）",
					grade: '19',
					disabledcwbbqykjzd_1_x_1: false,
					disabledcwbbqykjzd_1_x_2: false,
					cwbbqykjzd_1_x_1: {
						cellCode: "cwbbwxz_1_10_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					cwbbqykjzd_1_x_2: {
						cellCode: "cwbbwxz_1_10_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "补贴收入",
					grade: '22',
					disabledcwbbqykjzd_1_x_1: false,
					disabledcwbbqykjzd_1_x_2: false,
					cwbbqykjzd_1_x_1: {
						cellCode: "cwbbwxz_1_11_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					cwbbqykjzd_1_x_2: {
						cellCode: "cwbbwxz_1_11_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "营业外收入",
					grade: '23',
					disabledcwbbqykjzd_1_x_1: false,
					disabledcwbbqykjzd_1_x_2: false,
					cwbbqykjzd_1_x_1: {
						cellCode: "cwbbwxz_1_12_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					cwbbqykjzd_1_x_2: {
						cellCode: "cwbbwxz_1_12_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "减：营业外支出",
					grade: '25',
					disabledcwbbqykjzd_1_x_1: false,
					disabledcwbbqykjzd_1_x_2: false,
					cwbbqykjzd_1_x_1: {
						cellCode: "cwbbwxz_1_13_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					cwbbqykjzd_1_x_2: {
						cellCode: "cwbbwxz_1_13_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "四、利润总额（亏损总额以“－”号填列）",
					grade: '27',
					disabledcwbbqykjzd_1_x_1: false,
					disabledcwbbqykjzd_1_x_2: false,
					cwbbqykjzd_1_x_1: {
						cellCode: "cwbbwxz_1_14_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					cwbbqykjzd_1_x_2: {
						cellCode: "cwbbwxz_1_14_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "减：所得税",
					grade: '28',
					disabledcwbbqykjzd_1_x_1: false,
					disabledcwbbqykjzd_1_x_2: false,
					cwbbqykjzd_1_x_1: {
						cellCode: "cwbbwxz_1_15_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					cwbbqykjzd_1_x_2: {
						cellCode: "cwbbwxz_1_15_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "五、净利润（净亏损以“－”号填列）",
					grade: '30',
					disabledcwbbqykjzd_1_x_1: false,
					disabledcwbbqykjzd_1_x_2: false,
					cwbbqykjzd_1_x_1: {
						cellCode: "cwbbwxz_1_16_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					cwbbqykjzd_1_x_2: {
						cellCode: "cwbbwxz_1_16_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "补充资料：",
					disabledcwbbqykjzd_1_x_1: false,
					disabledcwbbqykjzd_1_x_2: false,
					cwbbqykjzd_1_x_1: {cellCode: "cwbbwxz_1_17_1",},
					cwbbqykjzd_1_x_2: {cellCode: "cwbbwxz_1_17_2",},
				}
			]
		
	}
	return obj
}
